import type { FC } from 'react';
import type { IconProps } from '../Icon';

export const Menu: FC<IconProps> = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
    height={24}
    width={24}
    strokeWidth={8}
    strokeMiterlimit="10"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <g fill="none" stroke={color}>
      <path d="M2.657,48l90.686,0" />
      <path d="M2.657,72.884l90.686,0" />
      <path d="M2.657,23.116l90.686,-0" />
    </g>
  </svg>
);
